import {FAILURE, PENDING, SUCCESS} from '../../constants'
import {useReducer} from 'react'
import _ from 'lodash'

const ActionTypes = {FAILURE, PENDING, SUCCESS, RESET: 'RESET'}
const InitialState = {
  total_page: 2,
  page: 1,
  data: [],
  errors: null,
  isLoading: false,
}

const Reducer = (state = InitialState, action) => {
  switch (action.type) {
    case ActionTypes.RESET:
      return _.cloneDeep(InitialState)
    case PENDING:
      return {
        ...state,
        data: (action.payload.page || 1) > 1 ? state.data : [],
        page: (action.payload.page || 1) > 1 ? state.page : 1,
        total_page: (action.payload.page || 1) > 1 ? state.total_page : 2,
        isLoading: true,
        error: null,
      }
    case SUCCESS:
      let _page = action.payload?.entity_objects?.length > 0 ? action.payload.page || 1 : state.page
      let entityObjects = Array.isArray(state.data.entity_objects) ? state.data.entity_objects : []
      return {
        ...state,
        isLoading: false,
        errors: null,
        data:
          (action.payload.page || 1) === 1
            ? action.payload || []
            : {
                ...state.data,
                entity_objects: [...entityObjects, ...action.payload.entity_objects],
              },
        page: _page,
        total_page:
          action.payload?.entity_objects?.length < action.payload.limit ? _page : _page + 1,
      }
    case FAILURE:
      return {
        ...state,
        errors: action.payload.errors,
        isLoading: false,
      }
    default:
      return state
  }
}

const useGetReservationEntityItemsReducer = (state = InitialState) => {
  return useReducer(Reducer, state)
}

export default useGetReservationEntityItemsReducer
export {ActionTypes, InitialState, Reducer}
